import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = () => {
    console.log("Reset password link sent to:", email);
    navigate("/forgot-password/otpverification"); // Go back to the previous page (Login)
  };
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const verifyEmail = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/forgot-password/verify-email`,
        {
          email: email,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        toast.success("OTP sent on Email");
      }
      navigate("/forgot-password/otpverification", { state: { email } });
      console.log("Response:", response.data);
    } catch (error) {
      toast.error(error.message);
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "#EBFAFF" }}
    >
      <Toaster position="top-right" reverseOrder={false} />
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content border-0 px-5 py-2"
          style={{
            boxShadow: "0px 0px 43px 0px #0000000D",
            borderRadius: "20px",
           maxHeight:"500px"
          }}
        >
          <div
            className="d-flex align-item-center mt-4 gap-1"
            style={{ color: "#909090" }}
          >
            <Icon
              icon="ep:back"
              className="fw-bold fs-4"
              onClick={() => navigate(-1)}
            />
            <h6
              className="fw-normal fs-6 pt-1 "
              style={{ fontFamily: "Noto Sans, sans-serif" }}
            >
              Back{" "}
            </h6>
          </div>

          <div className="modal-body d-flex justify-content-between">
            <h5
              className="fw-bold fs-4"
              style={{ fontFamily: "Noto Sans, sans-serif" }}
            >
              Forgot Password
            </h5>
            {/* <button type="button" className="btn-close" onClick={() => navigate(-1)}></button> */}
          </div>
          <div className="px-3">
            <p className="fw-normal fs-6" style={{ color: "#909090" }}>
              Please enter your email and we will send an OTP <br />
              code in the next step to reset your password{" "}
            </p>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Enter Email Id*
              </label>
              <input
                type="email"
                className="form-control rounded-pill px-5"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@raksoftech.com"
              />
              <Icon
                icon="material-symbols:mail-outline"
                style={{
                  position: "absolute",
                  top: "62",
                  left: "40px",
                  color: "#C3C3C3",
                }}
                className="fs-5"
              />
              {/* ✅ Show success icon if email is valid */}
              {isValidEmail(email) && (
                <Icon
                  icon="weui:done2-outlined"
                  style={{
                    color: "#00BF4C",
                    position: "absolute",
                    top: "33%",
                    right: "40px",
                    transform: "translateY(-50%)",
                  }}
                  className="fs-5"
                />
              )}
            </div>

            <div className="d-grid w-100 pt-5">
              <button
                className="text-white rounded-pill py-2"
                disabled={!isValidEmail(email)}
                onClick={verifyEmail}
                style={{ backgroundColor: "#00AFEF" }}
              >
                Send Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
